export default function trackUrlConversion () {
  if (process.env.NODE_ENV === 'production') {
    window.goog_report_conversion()
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/trackUrlConversion.js